import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        bingoLength : 0,
        bingoNum : null,
        important : null,
        infos : null
    },
    mutations: {},
    actions: {},
    getters:{
        bingoLength : function(state){
            return state.bingoLength
        },
        bingoNum : function (state) {
            if (state.bingoNum !== null) {
                var num_array = new Array()
                for (var index in state.bingoNum) num_array.push(state.bingoNum[index])
                return num_array.reverse()
            }
            return state.bingoNum
        },
        importantText : function (state) {
            return state.important
        },
        infos : function (state) {
            if (state.infos !== null){
                var info_array = new Array()
                for (var index in state.infos) info_array.push(state.infos[index])
                return info_array.reverse()
            }
            return state.infos
        }
    }
})
